import { Theme } from "@mui/material";



export const GradientStyles = (theme: Theme) => {
    return {
        gradient3: {
            backgroundColor: theme.colors["lime.500"]
        },
        gradient4: {
            backgroundImage: theme.utils.linearGradient("vertical", "amberToGreen"),
            backgroundSize: "auto 200%",
        },
        priority: {
            backgroundColor: theme.colors["yellow.400"],
            color: theme.colors["neutral.950"],
            
            "&:hover": {
            color: theme.colors["neutral.50"],        
            }
        },
    }
};